/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_PlaceholderInputs */

const id_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halo /dashboard!`)
};

const ms_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halo /dashboard!`)
};

const da_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hej /dashboard!`)
};

const de_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo /dashboard!`)
};

const en_us2_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello /dashboard!`)
};

const es_es2_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hola /dashboard!`)
};

const es_mx2_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hola /dashboard!`)
};

const fil_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello /dashboard!`)
};

const fr_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonjour /dashboard !`)
};

const it_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciao /dashboard!`)
};

const hu_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szia /dashboard!`)
};

const nl_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo /dashboard!`)
};

const no_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hei /dashboard!`)
};

const pl_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Witaj /dashboard!`)
};

const pt_br2_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá /painel!`)
};

const pt_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá /dashboard!`)
};

const ro_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salut /dashboard!`)
};

const fi_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hei /dashboard!`)
};

const sv_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hej /dashboard!`)
};

const vi_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xin chào /dashboard!`)
};

const tr_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merhaba /dashboard!`)
};

const cs_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahoj /dashboard!`)
};

const bg_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Здравейте /dashboard!`)
};

const ru_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привет, /dashboard!`)
};

const uk_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привіт /dashboard!`)
};

const ar_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرحبًا /dashboard!`)
};

const hi_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नमस्ते /dashboard!`)
};

const th_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สวัสดี /dashboard!`)
};

const ja_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`こんにちは /dashboard!`)
};

const zh_cn2_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您好 /dashboard!`)
};

const zh_hant1_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您好 /dashboard！`)
};

const ko_dashboard_placeholder = /** @type {(inputs: Dashboard_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/dashboard에 오신 것을 환영합니다!`)
};

/**
* | output |
* | --- |
* | "Hello /dashboard!" |
*
* @param {Dashboard_PlaceholderInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const dashboard_placeholder = /** @type {((inputs?: Dashboard_PlaceholderInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_PlaceholderInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dashboard_placeholder(inputs)
	if (locale === "ms") return ms_dashboard_placeholder(inputs)
	if (locale === "da") return da_dashboard_placeholder(inputs)
	if (locale === "de") return de_dashboard_placeholder(inputs)
	if (locale === "en-US") return en_us2_dashboard_placeholder(inputs)
	if (locale === "es-ES") return es_es2_dashboard_placeholder(inputs)
	if (locale === "es-MX") return es_mx2_dashboard_placeholder(inputs)
	if (locale === "fil") return fil_dashboard_placeholder(inputs)
	if (locale === "fr") return fr_dashboard_placeholder(inputs)
	if (locale === "it") return it_dashboard_placeholder(inputs)
	if (locale === "hu") return hu_dashboard_placeholder(inputs)
	if (locale === "nl") return nl_dashboard_placeholder(inputs)
	if (locale === "no") return no_dashboard_placeholder(inputs)
	if (locale === "pl") return pl_dashboard_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_dashboard_placeholder(inputs)
	if (locale === "pt") return pt_dashboard_placeholder(inputs)
	if (locale === "ro") return ro_dashboard_placeholder(inputs)
	if (locale === "fi") return fi_dashboard_placeholder(inputs)
	if (locale === "sv") return sv_dashboard_placeholder(inputs)
	if (locale === "vi") return vi_dashboard_placeholder(inputs)
	if (locale === "tr") return tr_dashboard_placeholder(inputs)
	if (locale === "cs") return cs_dashboard_placeholder(inputs)
	if (locale === "bg") return bg_dashboard_placeholder(inputs)
	if (locale === "ru") return ru_dashboard_placeholder(inputs)
	if (locale === "uk") return uk_dashboard_placeholder(inputs)
	if (locale === "ar") return ar_dashboard_placeholder(inputs)
	if (locale === "hi") return hi_dashboard_placeholder(inputs)
	if (locale === "th") return th_dashboard_placeholder(inputs)
	if (locale === "ja") return ja_dashboard_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_dashboard_placeholder(inputs)
	if (locale === "zh-Hant") return zh_hant1_dashboard_placeholder(inputs)
	return ko_dashboard_placeholder(inputs)
});
export { dashboard_placeholder as "dashboard.placeholder" }